/* Beneos shop browser (Phase 6.1): search-engine driven category page for battlemap
   releases, visually aligned with the My-Library search (beneos-search.css is loaded
   by the section; this file reproduces its facet paradigm: per-axis dropdown
   "Add biome..." in a left sidebar, selected values become removable .afchip pills
   under their own dropdown). Data: public Beneos DB catalog grouped into releases, mapped to
   buyable products via the app-proxy shopmap batch endpoint (handle, title,
   cloud_products, price group, download bytes, cover). Tiles use the Library
   .acard language plus a shop price/add-to-cart row; the on-cover chip states
   adventure compatibility (from the catalog), not the self-evident "animated". */
(function () {
  'use strict';

  /* Axes. 'type' and 'brightness' were dropped from the shop: they describe how a scene
     looks, which is a library concern, not a buying decision, and they made the sidebar
     twice as tall for nothing. Their i18n keys stay in place because the library still uses
     them. 'maps' and 'size' are DERIVED, not catalog properties: their values only exist
     once the shopmap merge has run (see the release mapping below). */
  var AXES = [
    { key: 'biom',      path: 'common.biome' },
    { key: 'adventure', path: 'battlemap.adventure' },
    { key: 'maps',      derived: 'bm' },
    { key: 'size',      derived: 'bytes' }
  ];

  /* Pack size steps, identical to lib/bm-price-class.php in the cloud, so the buyer sees the
     same grouping the price is built from. Order is the display order. */
  // hi is EXCLUSIVE throughout, so a label reading "1 to 3" ends at 4. Getting this wrong
  // silently drops the boundary counts (3, 5, 8, 12) into the last bucket.
  var MAP_BUCKETS = [
    { id: '1-3',    lo: 1,  hi: 4 },
    { id: '4-5',    lo: 4,  hi: 6 },
    { id: '6-8',    lo: 6,  hi: 9 },
    { id: '9-12',   lo: 9,  hi: 13 },
    { id: '13plus', lo: 13, hi: Infinity }
  ];
  var GB = 1024 * 1024 * 1024;
  var SIZE_BUCKETS = [
    { id: 'lt1', lo: 0,     hi: GB },
    { id: '1-3', lo: GB,    hi: 3 * GB },
    { id: '3-6', lo: 3 * GB, hi: 6 * GB },
    { id: 'gt6', lo: 6 * GB, hi: Infinity }
  ];

  function bucketOf(buckets, n) {
    if (!(n > 0)) return '';   // no number known: belongs in no bucket, never in a wrong one
    for (var i = 0; i < buckets.length; i++) if (n >= buckets[i].lo && n < buckets[i].hi) return buckets[i].id;
    return '';                 // outside every range: still no bucket, never a wrong one
  }
  function bucketsFor(key) { return key === 'maps' ? MAP_BUCKETS : SIZE_BUCKETS; }

  /* Adventure short codes. The chip used to spell out "Compatible with Descent into Avernus"
     across the cover of a tile a third of a column wide, where it got clipped anyway. The
     full sentence now lives in the tooltip and the accessible name.
     Keys are the UNLOCALIZED catalog values, so this holds in all 13 languages. */
  var ADV_SHORT = {
    'Curse of Strahd': 'CoS',
    'Descent into Avernus': 'DiA',
    'Tomb of Annihilation': 'ToA',
    'Rime of the Frostmaiden': 'RotF',
    'Storm Kings Thunder': 'SKT',
    "Storm King's Thunder": 'SKT',
    'Waterdeep Dragon Heist': 'WDH',
    'Out of the Abyss': 'OotA',
    'Homebrew': 'HB'
  };
  var ADV_MINOR = { of: 1, into: 1, the: 1, and: 1, a: 1, to: 1 };

  /* Fallback so a newly added adventure is never left without a chip: initials per word,
     filler words lowercase. A single word yields its first three letters. */
  function advShort(raw) {
    var s = String(raw || '').trim();
    if (!s) return '';
    if (ADV_SHORT[s]) return ADV_SHORT[s];
    var words = s.replace(/[^\w\s'-]/g, ' ').split(/\s+/).filter(Boolean);
    if (words.length === 1) return words[0].slice(0, 3).toUpperCase();
    return words.map(function (w) {
      var c = w.charAt(0);
      return ADV_MINOR[w.toLowerCase()] ? c.toLowerCase() : c.toUpperCase();
    }).join('');
  }

  /* Die Neuheitenreihe steht auf derselben Seite und braucht dasselbe Kuerzel. Sie holt es
     sich hier ab, statt die Tabelle ein drittes Mal zu fuehren (die Bibliothek hat ihre
     eigene in beneos-search.js). Wer den Wert zuerst hat, gewinnt: das Skript laeuft
     deferred, die Reihe rendert erst nach ihrer eigenen Abfrage. */
  if (!window.BeneosAdvShort) window.BeneosAdvShort = advShort;

  var SVG = {
    chev: '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 9l6 6 6-6"/></svg>',
    x: '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 5l14 14M19 5L5 19"/></svg>',
    cart: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="9" cy="20" r="1.6"/><circle cx="17" cy="20" r="1.6"/><path d="M3 4h2l2.4 11.2a1.4 1.4 0 0 0 1.37 1.1h7.9a1.4 1.4 0 0 0 1.37-1.08L20 8H6"/></svg>',
    check: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M4 12.5l5 5L20 6.5"/></svg>'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function humanBytes(b) {
    b = parseInt(b, 10) || 0;
    if (b <= 0) return '';
    var gb = b / 1073741824;
    if (gb >= 0.1) return gb.toFixed(1) + ' GB';
    return Math.max(1, Math.round(b / 1048576)) + ' MB';
  }

  function init() {
    var root = document.getElementById('beneos-shop-browser');
    if (!root || !window.BeneosDB) return;
    var cfgEl = document.getElementById('beneos-shop-browser-cfg');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var S = cfg.strings || {};
    var locale = cfg.locale || 'en';
    var proxyUrl = cfg.proxyUrl || '/apps/beneos/library';
    var pageSize = parseInt(cfg.pageSize, 10) || 24;

    var priceMap = {};
    var pmEl = document.querySelector('.beneos-cardprice-data');
    if (pmEl) { try { priceMap = (JSON.parse(pmEl.textContent) || {}).priceMap || {}; } catch (e) {} }

    var B = window.Beneos || {};
    function money(cents) {
      if (B.cart && typeof B.cart.formatMoney === 'function') return B.cart.formatMoney(cents);
      return (Math.round(cents) / 100).toFixed(2);
    }

    var elSide = root.querySelector('[data-sb-facets]');
    var elGrid = root.querySelector('[data-sb-grid]');
    var elCount = root.querySelector('[data-sb-count]');
    var elMore = root.querySelector('[data-sb-more]');
    var elSearch = root.querySelector('[data-sb-q]');
    var elSort = root.querySelector('[data-sb-sort]');

    var matrix = null;
    var releases = [];
    var filtered = [];
    var page = 1;
    var sel = {};
    AXES.forEach(function (a) { sel[a.key] = []; });
    var openMenu = null;
    var q = '';
    var sort = 'newest';

    function loc(path, v) { return window.BeneosDB.localizeLabel(matrix, path, v, locale); }
    function axisLabel(key) { return S['axis_' + key] || key; }

    function releaseNum(key) {
      var m = /^bm_(\d+)/.exec(key);
      if (m) return parseInt(m[1], 10);
      var t = /(\d+)[a-z]?$/.exec(key);
      return t ? parseInt(t[1], 10) : 0;
    }

    Promise.all([
      window.BeneosDB.load('battlemap'),
      (locale === 'en') ? Promise.resolve(null) : window.BeneosDB.load('i18n').catch(function () { return null; })
    ]).then(function (res) {
      var content = res[0] && res[0].content ? res[0].content : (res[0] || {});
      matrix = res[1];

      var byRel = {};
      Object.keys(content).forEach(function (key) {
        var e = content[key]; if (!e) return;
        var p = e.properties || {};
        var rd = String(p.release_dir || '');
        if (!rd) return;
        var r = byRel[rd] || (byRel[rd] = {
          key: rd, num: releaseNum(rd), date: '', bm: 0, sc: 0, names: [], axes: {}, thumb: null
        });
        // Maximum ueber alle Szenen eines Release, genau wie es app-proxy.php fuer
        // die Fresh-Rail tut. Nur release_date, niemals updated_date: ein Re-Upload
        // ist kein neues Release.
        var rdate = String(p.release_date || '');
        if (rdate > r.date) r.date = rdate;
        var type = String(p.type || '');
        if (/^battlemap$/i.test(type)) r.bm++;
        else if (/^scenery$/i.test(type)) r.sc++;
        if (e.name) r.names.push(String(e.name));
        AXES.forEach(function (a) {
          if (a.derived) return; // filled after the shopmap merge, the numbers are not in the catalog
          var v = p[a.key];
          if (v == null) return;
          (Array.isArray(v) ? v : [v]).forEach(function (x) {
            x = String(x);
            if (!x || x === 'None') return;
            (r.axes[a.key] = r.axes[a.key] || {})[x] = true;
          });
        });
        if (!r.thumb && p.thumbnail) r.thumb = window.BeneosDB.thumbUrl('battlemap', p.thumbnail);
      });

      var keys = Object.keys(byRel);
      var chunks = [];
      for (var i = 0; i < keys.length; i += 50) chunks.push(keys.slice(i, i + 50));
      return chunks.reduce(function (prev, chunk) {
        return prev.then(function (acc) {
          var u = proxyUrl + (proxyUrl.indexOf('?') >= 0 ? '&' : '?') +
            'resource=shopmap&keys=' + encodeURIComponent(chunk.join(','));
          return fetch(u, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (j) {
              var d = (j && j.data) || {};
              Object.keys(d).forEach(function (k) { acc[k] = d[k]; });
              return acc;
            })
            .catch(function () { return acc; });
        });
      }, Promise.resolve({})).then(function (map) {
        releases = keys
          .filter(function (k) { return map[k] && map[k].handle; })
          .map(function (k) {
            var r = byRel[k];
            var m = map[k];
            var cents = 0, priceOk = true;
            (m.pg || []).forEach(function (g) {
              var p = priceMap[String(g.v)];
              if (p == null) { priceOk = false; return; }
              cents += p * (g.q || 0);
            });
            var adv = r.axes.adventure ? Object.keys(r.axes.adventure) : [];
            var bytes = m.bytes || 0;
            // Derived axes: the scene count comes from the catalog, the download size only
            // from shopmap, so both buckets can only be decided here. A release with no
            // number lands in no bucket rather than in a wrong one.
            var mapsB = bucketOf(MAP_BUCKETS, r.bm);
            var sizeB = bucketOf(SIZE_BUCKETS, bytes);
            if (mapsB) r.axes.maps = {}, r.axes.maps[mapsB] = true;
            if (sizeB) r.axes.size = {}, r.axes.size[sizeB] = true;
            return {
              key: k, num: r.num, date: r.date, bm: r.bm, sc: r.sc, axes: r.axes,
              names: r.names.join(' ').toLowerCase(),
              title: m.title || k,
              handle: m.handle,
              cp: (m.cp || []).join(','),
              thumb: m.thumb || r.thumb,
              bytes: bytes,
              adventure: adv.length ? adv[0] : '',
              cents: priceOk ? cents : null,
              base: parseFloat(m.dp || '0') || 0
            };
          });
        /* Neuheiten-Marke. Dieselbe Regel wie in der Bibliothek (beneos-home.js): das
           groesste Erscheinungsdatum im Satz gewinnt, und alle Releases dieses Tages
           tragen die Marke. Kein Zeitfenster in Tagen, denn der Takt der Veroeffent-
           lichungen schwankt und ein festes Fenster waere mal leer und mal voll.
           Die Reihe "New Releases" darueber ist am 2026-08-19 entfallen, seit die
           Sortierung ohnehin nach Erscheinungsdatum laeuft; diese Marke ist ihr Ersatz
           und kostet keine Hoehe. */
        var newestDate = '';
        releases.forEach(function (r) { if (r.date && r.date > newestDate) newestDate = r.date; });
        releases.forEach(function (r) { r.isNew = newestDate !== '' && r.date === newestDate; });
        renderAll();
      });
    }).catch(function () {
      if (elCount) elCount.textContent = S.load_error || 'Could not load the catalog.';
    });

    // ---- facet sidebar (Library facet-sel paradigm) --------------------------------
    // A row of loose chips per axis was tried and rejected: picking a value meant hunting
    // through a wall of look-alike buttons. The dropdown-plus-active-chip pattern is the one
    // the Library already teaches and the one people recognise, so both surfaces stay the same.
    function axisFor(key) { for (var i = 0; i < AXES.length; i++) if (AXES[i].key === key) return AXES[i]; return AXES[0]; }

    /* Derived axes carry bucket ids, not catalog values, so they are labelled from the
       section strings and keep their defined order instead of sorting by frequency. */
    function valueLabel(key, v) {
      var a = axisFor(key);
      if (!a.derived) return loc(a.path, v);
      return S['bucket_' + key + '_' + v.replace(/[^a-z0-9]/gi, '_')] || v;
    }

    function optionsFor(key) {
      var counts = {};
      releases.forEach(function (r) {
        Object.keys(r.axes[key] || {}).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
      });
      var a = axisFor(key);
      var list = Object.keys(counts).map(function (v) {
        return { value: v, label: valueLabel(key, v), count: counts[v] };
      });
      if (a.derived) {
        var order = bucketsFor(key).map(function (b) { return b.id; });
        list.sort(function (x, y) { return order.indexOf(x.value) - order.indexOf(y.value); });
      } else {
        list.sort(function (x, y) { return y.count - x.count || x.label.localeCompare(y.label); });
      }
      return list;
    }

    function facetSelect(a) {
      var selected = sel[a.key];
      var open = openMenu === a.key;
      var opts = optionsFor(a.key).filter(function (o) { return selected.indexOf(o.value) === -1; });
      var ph = (S.add_facet || 'Add {label}...').replace('{label}', axisLabel(a.key).toLowerCase());
      var html = '<div class="facet-sel" data-facet="' + esc(a.key) + '">' +
        '<button type="button" class="facet-sel-trigger' + (open ? ' open' : '') + '" aria-expanded="' + (open ? 'true' : 'false') + '" data-facet-toggle="' + esc(a.key) + '">' +
          '<span class="facet-sel-ph">' + esc(ph) + '</span>' +
          '<span class="facet-sel-chev' + (open ? ' flip' : '') + '">' + SVG.chev + '</span></button>';
      if (open) {
        html += '<div class="facet-sel-menu">' + (opts.length ? opts.map(function (o) {
          return '<button type="button" class="facet-sel-opt" data-facet-add="' + esc(o.value) + '" data-facet-key="' + esc(a.key) + '"><span>' + esc(o.label) + '</span><span class="facet-sel-cnt">' + o.count + '</span></button>';
        }).join('') : '<div class="facet-sel-empty">' + esc(S.all_selected || 'All values selected') + '</div>') + '</div>';
      }
      if (selected.length) {
        html += '<div class="facet-sel-active">' + selected.map(function (v) {
          return '<button type="button" class="afchip" data-facet-rm="' + esc(v) + '" data-facet-key="' + esc(a.key) + '">' + esc(valueLabel(a.key, v)) + '<span class="x">' + SVG.x + '</span></button>';
        }).join('') + '</div>';
      }
      return html + '</div>';
    }

    function renderSidebar() {
      if (!elSide) return;
      var html = '<div class="brw-filter-h"><span class="t">' + esc(S.refine || 'Refine') + '</span>' +
        '<button type="button" class="reset" data-reset>' + esc(S.reset || 'Reset') + '</button></div>';
      AXES.forEach(function (a) {
        // An axis with nothing to offer is left out rather than shown as an empty dropdown.
        if (!optionsFor(a.key).length) return;
        var n = sel[a.key].length;
        html += '<div class="fchip-grp"><div class="fchip-grp-h"><span class="t">' + esc(axisLabel(a.key)) + '</span>' +
          (n ? '<span class="s">' + n + ' ' + esc(S.active_n || 'active') + '</span>' : '') + '</div>' +
          facetSelect(a) + '</div>';
      });
      elSide.innerHTML = html;
    }

    /* No separate "active filters" strip above the grid. Each dropdown already carries its own
       selection underneath it, and repeating the same chips a second time was both redundant
       and a second gold source in the viewport (DESIGN.md, One Seal Rule). */

    // ---- filtering + tiles ---------------------------------------------------------
    function matches(r) {
      for (var i = 0; i < AXES.length; i++) {
        var a = AXES[i].key;
        if (!sel[a].length) continue;
        var have = r.axes[a] || {};
        var hit = false;
        for (var s = 0; s < sel[a].length; s++) if (have[sel[a][s]]) { hit = true; break; }
        if (!hit) return false;
      }
      if (q) {
        var hay = (r.title + ' ' + r.names).toLowerCase();
        var terms = q.split(/\s+/).filter(Boolean);
        for (var t = 0; t < terms.length; t++) if (hay.indexOf(terms[t]) < 0) return false;
      }
      return true;
    }

    function tile(r) {
      var metaBits = [];
      if (r.bm) metaBits.push(r.bm + ' ' + (r.bm === 1 ? (S.map_one || 'map') : (S.map_other || 'maps')));
      if (r.sc) metaBits.push(r.sc + ' ' + (r.sc === 1 ? (S.sc_one || 'scenery') : (S.sc_other || 'sceneries')));
      var size = humanBytes(r.bytes);
      if (size) metaBits.push(size);
      var advChip = '';
      if (r.adventure) {
        // Short code on the cover, full sentence in the tooltip AND in the accessible name,
        // so it is not information the mouse alone gets.
        var full = (S.compatible_with || 'Compatible with') + ' ' + loc('battlemap.adventure', r.adventure);
        advChip = '<span class="rls-adv-chip sb-adv" title="' + esc(full) + '" aria-label="' + esc(full) + '">' +
          esc(advShort(r.adventure)) + '</span>';
      }
      // Oben rechts sitzt bereits der Abenteuer-Chip, die Neuheiten-Marke steht deshalb links.
      var newChip = r.isNew ? '<span class="sb-new">' + esc(S.new_badge || 'New') + '</span>' : '';
      return '<article class="acard sb-card" data-key="' + esc(r.key) + '">' +
        '<a class="acard-thumb" data-aspect="wide" href="/products/' + esc(r.handle) + '" aria-label="' + esc(r.title) + '">' +
          (r.thumb ? '<img src="' + esc(r.thumb) + '" alt="' + esc(r.title) + ', animated battle map pack" loading="lazy">' : '<span class="glyph" aria-hidden="true">' + esc((r.title || '?').charAt(0)) + '</span>') +
          newChip +
          advChip +
        '</a>' +
        '<div class="acard-body">' +
          '<div class="acard-name"><a href="/products/' + esc(r.handle) + '">' + esc(r.title) + '</a></div>' +
          '<div class="acard-sub">' + esc(metaBits.join(' · ')) + '</div>' +
          '<div class="sb-foot">' +
            '<span class="sb-price">' + (r.cents != null ? money(r.cents) : '') + '</span>' +
            '<button type="button" class="sb-add" data-cp="' + esc(r.cp) + '" aria-label="' + esc(S.add || 'Add to cart') + '" title="' + esc(S.add || 'Add to cart') + '">' + SVG.cart + '</button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }

    function renderGrid() {
      if (!elGrid) return;
      var slice = filtered.slice(0, page * pageSize);
      elGrid.innerHTML = slice.map(tile).join('');
      if (elCount) {
        var tpl = S.results || '{n} of {total} packs';
        elCount.innerHTML = esc(tpl).replace('{n}', '<b>' + filtered.length + '</b>').replace('{total}', String(releases.length));
      }
      if (elMore) elMore.style.display = (filtered.length > slice.length) ? '' : 'none';
    }

    function apply() {
      filtered = releases.filter(matches);
      // Frische nach dem echten Erstveroeffentlichungsdatum, nicht nach der
      // Release-Nummer. Die Nummer stimmt nur fuer die Hauptreihe: bm_0078b ist am
      // 2026-07-26 erschienen und landete nach Nummer sortiert auf Platz 78.
      // Gleichstand bricht der Verzeichnisname absteigend, dieselbe Regel wie in
      // app-proxy.php, damit Rail und Browser bei Drops desselben Tages dieselbe
      // Reihenfolge zeigen. Ein Release ohne Datum sinkt ans Ende statt als
      // aeltestes zu gelten.
      if (sort === 'newest') filtered.sort(function (a, b) {
        var c = (b.date || '').localeCompare(a.date || '');
        return c !== 0 ? c : b.key.localeCompare(a.key);
      });
      else if (sort === 'price_asc') filtered.sort(function (a, b) { return a.base - b.base; });
      else if (sort === 'price_desc') filtered.sort(function (a, b) { return b.base - a.base; });
      else filtered.sort(function (a, b) { return a.title.localeCompare(b.title); });
      renderGrid();
    }

    /* Der Platzhalter nennt beim Rendern die Zahl der Produkte in der Shopify-Sammlung,
       und die stimmt nicht mit dem ueberein, was hier durchsuchbar ist: gezaehlt wird ein
       Release erst, wenn es ein Shop-Produkt hat, und die Sammlung enthaelt daneben
       Sammelpakete. Gemessen am 2026-08-06 standen 137 im Feld und 134 in der Trefferzeile.
       Ersetzt wird nur die erste Zahl, damit der uebersetzte Satz unangetastet bleibt und
       kein weiterer Sprachschluessel entsteht. */
    function syncSearchCount() {
      if (!elSearch) return;
      var ph = elSearch.getAttribute('placeholder') || '';
      if (!/\d/.test(ph)) return;
      // Trennzeichen als Fluchtfolge, nicht als Zeichen: Franzoesisch trennt Tausender mit
      // einem schmalen geschuetzten Leerzeichen, und das sieht im Quelltext aus wie nichts.
      elSearch.setAttribute('placeholder', ph.replace(/\d+(?:[.,\u00a0\u202f ]\d{3})*/, String(releases.length)));
    }

    function renderAll() {
      syncSearchCount();
      renderSidebar();
      apply();
    }

    // ---- events --------------------------------------------------------------------
    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-facet-toggle]'))) {
        var k = t.getAttribute('data-facet-toggle');
        openMenu = (openMenu === k) ? null : k;
        renderSidebar();
        return;
      }
      if ((t = e.target.closest('[data-facet-add]'))) {
        var key = t.getAttribute('data-facet-key');
        var val = t.getAttribute('data-facet-add');
        if (sel[key].indexOf(val) === -1) sel[key].push(val);
        openMenu = null;
        page = 1;
        renderAll();
        return;
      }
      if ((t = e.target.closest('[data-facet-rm]'))) {
        var key2 = t.getAttribute('data-facet-key');
        var val2 = t.getAttribute('data-facet-rm');
        sel[key2] = sel[key2].filter(function (v) { return v !== val2; });
        page = 1;
        renderAll();
        return;
      }
      if ((t = e.target.closest('[data-reset]'))) {
        AXES.forEach(function (a) { sel[a.key] = []; });
        q = '';
        if (elSearch) elSearch.value = '';
        openMenu = null;
        page = 1;
        renderAll();
        return;
      }
      if ((t = e.target.closest('.sb-add'))) {
        onAdd(t);
      }
    });
    document.addEventListener('click', function (e) {
      if (openMenu && !e.target.closest('.facet-sel')) { openMenu = null; renderSidebar(); }
    });

    if (elMore) elMore.addEventListener('click', function () { page++; renderGrid(); });
    if (elSearch) {
      var deb = null;
      elSearch.addEventListener('input', function () {
        clearTimeout(deb);
        deb = setTimeout(function () { q = elSearch.value.trim().toLowerCase(); page = 1; apply(); }, 180);
      });
    }
    if (elSort) elSort.addEventListener('change', function () { sort = elSort.value; page = 1; apply(); });

    function onAdd(btn) {
      if (!window.BeneosCartAdd) return;
      var art = btn.closest('.acard');
      var key = art ? art.getAttribute('data-key') : '';
      var rel = null;
      for (var i = 0; i < releases.length; i++) if (releases[i].key === key) { rel = releases[i]; break; }
      if (!rel) return;
      btn.disabled = true;
      var summaryBits = [];
      if (rel.bm) summaryBits.push(rel.bm + ' ' + (S.map_other || 'maps'));
      if (rel.sc) summaryBits.push(rel.sc + ' ' + (S.sc_other || 'sceneries'));
      window.BeneosCartAdd.add(rel.cp, {
        title: rel.title,
        url: '/products/' + rel.handle,
        thumb: rel.thumb || '',
        summary: summaryBits.join(' · '),
        packLabel: S.pack_label || 'Pack',
        proxyUrl: proxyUrl
      }).then(function (state) {
        if (state === 'added') { btn.innerHTML = SVG.check; btn.classList.add('ok'); btn.title = S.added || 'Added'; }
        else if (state === 'owned') { btn.classList.add('own'); btn.title = S.owned || 'Owned'; }
        else { btn.disabled = false; return; }
        setTimeout(function () {
          btn.innerHTML = SVG.cart;
          btn.classList.remove('ok');
          btn.title = S.add || 'Add to cart';
          btn.disabled = false;
        }, 2400);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
